import RTableLayout from "../../../layout/RTableLayout";
import { CMargin, DText, Flex, Row } from "../../../../../styles/CommonStyles";
import { formatDate } from "../../../../../core/utils/common";
import Text from "../../../../../core/utils/Text";
import { useMainContext } from "../../../../../core/contexts/main";
import { RespIndex } from "../../../../../styles/main/MainCommonStyles";



const RRewardListTable = ({
    data
}) => {

    const { lang } = useMainContext()
    const { data: transactions } = data

    return (
        <RTableLayout
            data={data}
        >
            {transactions?.data?.map((item, idx) => {

                return (
                    <Row cs={'100%'} index={idx} key={item._id}>


                        <CMargin margin={'8px'} />
                        <Flex justify={'space-between'}>
                            <DText fontSize={'s'} main>
                                <Text tid={'amount'} /> :
                            </DText>
                            {item?.record_id || "-"}
                        </Flex>

                        <CMargin margin={'8px'} />
                        <Flex justify={'space-between'}>
                            <DText fontSize={'s'} main>
                                <Text tid={'amount'} /> :
                            </DText>
                            {item?.amount}
                        </Flex>

                        <CMargin margin={'8px'} />
                        <Flex justify={'space-between'}>
                            <DText fontSize={'s'} main>
                                <Text tid={'amount'} /> :
                            </DText>
                            {item?.currency}
                        </Flex>


                        <Flex justify={'space-between'}>
                            <DText fontSize={'s'} main>
                                <Text tid={'date'} /> :
                            </DText>
                            <DText fontSize={'s'} main>
                                {formatDate(item.createdAt, 'date', lang)}
                            </DText>
                        </Flex>
                        <Flex justify={'space-between'}>
                            <DText fontSize={'s'} main>
                                <Text tid={'time'} /> :
                            </DText>
                            <DText fontSize={'s'} main>
                                {formatDate(item.createdAt, 'time', lang)}
                            </DText>
                        </Flex>
                        <RespIndex>
                            {idx + 1}
                        </RespIndex>
                    </Row>
                )
            })}
        </RTableLayout>
    )
}

export default RRewardListTable
